import OtpInput, { OTPInputProps } from "react-otp-input";
import React from "react";
import "./totp.scss";

interface TotpInputProps extends Omit<OTPInputProps, "renderInput"> {
    isRequired?: boolean;
}

export const TotpInput = ({ numInputs = 6, isRequired, ...props }: TotpInputProps) => {
    return (
        <div className={"totp d-flex flex-column justify-content-center mx-auto w-auto"}>
            <OtpInput
                shouldAutoFocus
                numInputs={numInputs}
                containerStyle={"totp__container gap-2-1 flex-wrap justify-content-center"}
                inputStyle={"totp__input form-control"}
                renderInput={props => <input {...props} placeholder={props?.placeholder ?? "-"} />}
                {...props}
            />
            {isRequired && <small className={"text-neutral-700"}>* Este código es obligatorio</small>}
        </div>
    );
};
